export default __webpack_public_path__ + "static/media/close.c6a5cd86.svg";